import cx from "classnames";

import HorizontalOverflow from "client/common/components/display/HorizontalOverflow";

import { FactsBlock as FactsBlockType } from "../../types";
import MarkdownText from "../helper/MarkdownText";

import styles from "../../styles/FactsBlock.module.less";

type FactsBlockProps = {
  className: string;
  block: FactsBlockType;
};

const FactsBlock = ({ block, className }: FactsBlockProps) => {
  return (
    <HorizontalOverflow
      classNames={{ scroller: cx(styles.container, className), button: styles.button }}
    >
      {block.facts.map((fact) => (
        <div className={styles.fact} key={fact.label}>
          {fact.label && (
            <p className={styles.label}>
              <MarkdownText value={fact.label} />
            </p>
          )}
          {fact.label && fact.description && <div className={styles.divider} />}
          {fact.description && (
            <p className={styles.value}>
              <MarkdownText value={fact.description} />
            </p>
          )}
        </div>
      ))}
    </HorizontalOverflow>
  );
};

export default FactsBlock;
